import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuditoriaDto } from '../dto/auditoria/auditoria.dto';

@Injectable({
  providedIn: 'root',
})
export class AuditoriaService {
  private apiUrl = environment.apiUrl;
  private baseUrl = `${this.apiUrl}/auditoria`;

  constructor(private http: HttpClient) {}

  obtenerCambiosRecientesPorUsuario(
    usuarioId: number
  ): Observable<AuditoriaDto[]> {
    return this.http.get<AuditoriaDto[]>(
      `${this.baseUrl}/usuario/${usuarioId}/cambios-recientes`
    );
  }
}
